import { Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { appStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { WorkInstructionUIStore } from '../../stores/work-instruction.ui-store'

interface ApiErrorShape {
  response?: { status?: number; data?: { detail?: string } }
}

interface Props {
  store: WorkInstructionUIStore
}

export const CancelHousekeepingPlanDialog = observer(({ store }: Props) => {
  const { t } = useTranslate()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const pendingCount = store.pendingHousekeepingMovesCount

  const handleConfirm = async () => {
    setIsSubmitting(true)
    try {
      await store.cancelSelectedHousekeepingPlan()
      appStore.setShowAlert(
        'success',
        t('internalMoves.cancelDialog.success', 'Housekeeping plan cancelled.'),
      )
      store.closeCancelHousekeepingPlanDialog()
    } catch (error) {
      const detail = (error as ApiErrorShape)?.response?.data?.detail
      appStore.setShowAlert(
        'error',
        detail ?? t('internalMoves.cancelDialog.error', 'Could not cancel housekeeping plan.'),
      )
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <ConfirmationDialog
      open={store.isCancelHousekeepingPlanDialogOpen}
      title={t('internalMoves.cancelDialog.title', 'Cancel housekeeping plan')}
      primaryActionText={t('internalMoves.cancelDialog.confirm', 'Yes, cancel group')}
      closeLabel={t('internalMoves.cancelDialog.dismiss', 'No, keep plan')}
      isLoading={isSubmitting}
      onClose={() => store.closeCancelHousekeepingPlanDialog()}
      onConfirm={handleConfirm}
    >
      <Typography variant='body1'>
        {t(
          'internalMoves.cancelDialog.body',
          'This will cancel {pendingCount} pending move(s). In-progress moves will complete normally.',
          { pendingCount },
        )}
      </Typography>
    </ConfirmationDialog>
  )
})
